<template>
  <form v-if="!isLoading">
    <div class="columns">
      <div class="column is-6">
        <h2 class="title is-5" v-t="'contact_settings'" />

        <b-field :label="$t('labels.address')">
          <b-input
            v-model="settings.contact.address"
            :placeholder="$t('placeholders.address')" />
        </b-field>

        <b-field :label="$t('labels.phone')">
          <b-input
            v-model="settings.contact.phone"
            :placeholder="$t('placeholders.phone')" />
        </b-field>

        <b-field :label="$t('labels.email')">
          <b-input
            type="email"
            v-model="settings.contact.email"
            :placeholder="$t('placeholders.email')" />
        </b-field>
      </div>

      <div class="column is-6">
        <h2 class="title is-5" v-t="'smtp_settings'" />

        <div class="columns has-margin-bottom-none">
          <div class="column">
            <b-field :label="$t('labels.host')">
              <b-input
                v-model="settings.smtp.host"
                :placeholder="$t('placeholders.host')" />
            </b-field>
          </div>

          <div class="column is-3">
            <b-field :label="$t('labels.encryption')">
              <b-input
                v-model="settings.smtp.encryption"
                :placeholder="$t('placeholders.encryption')" />
            </b-field>
          </div>

          <div class="column is-3">
            <b-field :label="$t('labels.port')">
              <b-input
                v-model="settings.smtp.port"
                :placeholder="$t('placeholders.port')" />
            </b-field>
          </div>
        </div>

        <b-field :label="$t('labels.username')">
          <b-input
            v-model="settings.smtp.username"
            :placeholder="$t('placeholders.username')" />
        </b-field>

        <b-field :label="$t('labels.password')">
          <b-input
            type="password"
            v-model="settings.smtp.password"
            :placeholder="$t('placeholders.password')"
            password-reveal />
        </b-field>
      </div>
    </div>

    <button
      type="submit"
      class="button is-danger"
      @click.prevent="saveSettings($event)">
      <b-icon icon="save" />
      <span v-t="'save'" />
    </button>
  </form>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import LoadingContent from './LoadingContent'

export default {
  name: 'SettingsForm',
  components: { LoadingContent },
  data () {
    return {
      isLoading: true,
      settings: {
        contact: {
          address: '',
          phone: '',
          email: ''
        },
        smtp: {
          host: '',
          encryption: '',
          port: '',
          username: '',
          password: ''
        }
      }
    }
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    fetchSettings () {
      this.isLoading = true
      API.settings.all(settings => {
        this.settings = settings
        this.isLoading = false
      })
    },
    saveSettings (event) {
      let btn = event.currentTarget

      btn.classList.add('is-loading')

      API.settings.updateAll(this.settings, settings => {
        this.$snotify.success(this.$t('alert_message'), this.$t('alert_title'))
        btn.classList.remove('is-loading')
      })
    }
  }
}
</script>

<i18n>
{
  "en-US": {
    "contact_settings": "Contact Settings",
    "smtp_settings": "SMTP Settings",
    "labels": {
      "address": "Address",
      "phone": "Phone",
      "email": "Email",
      "host": "Host",
      "encryption": "Encryption",
      "port": "Port",
      "username": "Username",
      "password": "Password"
    },
    "placeholders": {
      "address": "Enterprise address",
      "phone": "Contact phone",
      "email": "Email address for support",
      "host": "Ex.: smtp.domain.com",
      "encryption": "Ex.: TLS",
      "port": "Ex.: 587",
      "username": "Ex.: user@domain.com",
      "password": "Access password"
    },
    "save": "Save informations",
    "alert_title": "Success",
    "alert_message": "Data successfully updated!"
  },
  "pt-BR": {
    "contact_settings": "Dados de Contato",
    "smtp_settings": "Dados de SMTP",
    "labels": {
      "address": "Endereço",
      "phone": "Telefone",
      "email": "E-mail",
      "host": "Host",
      "encryption": "Criptografia",
      "port": "Porta",
      "username": "Nome de Usuário",
      "password": "Senha"
    },
    "placeholders": {
      "address": "Endereço da empresa",
      "phone": "Telefone de contato",
      "email": "Endereço de e-mail para suporte",
      "host": "Ex.: smtp.dominio.com.br",
      "encryption": "Ex.: TLS",
      "port": "Ex.: 587",
      "username": "Ex.: usuario@dominio.com.br",
      "password": "Senha de acesso"
    },
    "save": "Salvar informações",
    "alert_title": "Successo",
    "alert_message": "Configurações alteradas com sucesso!"
  }
}
</i18n>
